module.exports = __webpack_public_path__ + "assets/warn.21d947e3.svg";